import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
const Overlay = ({
  component,
  zIndex,
  background,
  borderRadius,
  boxShadow,
  transition,
  visible = false,
  className,
  children
}) => /* @__PURE__ */ jsx(
  Box,
  {
    component,
    position: "absolute",
    zIndex,
    pointerEvents: "none",
    background,
    borderRadius,
    boxShadow,
    transition,
    inset: 0,
    opacity: !visible ? 0 : void 0,
    className,
    children
  }
);
export {
  Overlay
};
